<template>
  <div class="doctor-finder-map-results-pagination" style="position: sticky; bottom: 0">
    <nav class="doctor-finder-pagination-nav" :aria-label="resultText('pagination_label')">
      <small class="doctor-finder-pagination-label"
        ><span class="doctor-finder-pagination-label__results-count">{{ countLabel }}</span
        ><span v-if="bounds">{{ withinBoundsText }}</span
        ><template v-if="mapSettings?.boundsScopingEnabled"
          ><br /><sp-switch
            class="sp-finder-map-bounds-mode"
            name="scope_results_to_map_bounds"
            :data-testid="TestId.finder.mapBoundsMode"
            :label="mapText('auto')"
            :checked="viewport.auto.value"
            @change="changeMode"
          ></sp-switch></template
      ></small>
      <div v-if="payload.page_count > 1" class="doctor-finder-pagination">
        <sp-button
          variant="text"
          color="custom"
          class="finder-result-control pagination-item pagination-item--prev"
          :aria-label="resultText('previous')"
          :data-testid="TestId.finder.mapPaginationPrev"
          :disabled="page <= 1"
          :class="previousClass"
          @click="previous"
        ></sp-button>
        <sp-button
          variant="text"
          color="custom"
          class="finder-result-control pagination-item pagination-item--next"
          :aria-label="resultText('next')"
          :data-testid="TestId.finder.mapPaginationNext"
          :disabled="page >= payload.page_count"
          :class="nextClass"
          @click="next"
        ></sp-button>
      </div>
    </nav>
  </div>
</template>

<script setup>
import { TestId } from "#/test-ids";
import { resultText } from "#ce/components/SpFinder/lib/result-text";
import { mapText } from "#ce/apps/SpFinderMap/lib/map-text";
import { useFinderMapPagination } from "#ce/apps/SpFinderMap/composables/useFinderMapPagination";
const props = defineProps({
  payload: { type: Object, required: true },
  commands: { type: Object, required: true },
  viewport: { type: Object, default: undefined },
  mapSettings: { type: Object, default: undefined },
  bounds: { type: [Object, String], default: undefined },
});
const { page, previousClass, nextClass, countLabel, withinBoundsText, changeMode, previous, next } =
  useFinderMapPagination(props);
</script>
